const moment = require('moment')

export default {
  namespaced: true,
  state: {
    day1: [
      {
        thumbnail: '/img/channel/01.png',
        title: '朝の会だよ！みんな大集合〜！',
        description: '1日を楽しむためのスケジュールやイベント主催者を紹介☆<br>各チャンネルのおすすめプログラムや今日の楽しみ方をぎゅっとご紹介します♪',
        start: '10:00',
        end: '10:30',
        link: 'https://www.instagram.com/littlemama_official/'
      },
      {
        thumbnail: '/img/channel/02.png',
        title: '6月生まれの誕生日お祝い会',
        description: '6月生まれのご家族がいるママたち集まれ～～～！<br>みんなで誕生日をお祝いしましょう♪<br>同じ誕生日の人にも出会えるかも？！<br>お祝いだけじゃなく、お誕生日のプレゼント事情やご飯事情についてもコメントで盛り上がろう！<br>ご家族特有のお誕生日儀式をお持ちの方もコメントで教えてください☆',
        start: '11:30',
        end: '12:00',
        link: 'https://www.instagram.com/littlemama_official/'
      },
      {
        thumbnail: '/img/channel/03.png',
        title: '#リトルフォトコン',
        description: '「＃リトル・フォトコン」をつけて「＠littlemama_officialのアカウントをタグ付け」してInstagramに投稿してね！<br>素敵なお写真はコーナー内で紹介されるかも☆<br>テーマは「ステイホームベイビー部門」と「ステイホームキッズ部門」の2部門！<br>当日、社内で選定したグランプリも発表いたします！<br>各部門グランプリに輝いた2名の方には、7月オンラインフェスタの広告モデルになれちゃう☆<br>みなさんから寄せられた可愛い癒し写真を見てみんなで盛り上がろう♪',
        start: '14:00',
        end: '14:30',
        link: 'https://www.instagram.com/littlemama_official/'
      },
      {
        thumbnail: '/img/channel/04.png',
        title: '抽選会＆最優秀コンテンツ賞発表',
        description: 'プレゼント抽選会の当選者や最優秀コンテンツ賞を発表します☆<br>みんなの今日の感想も教えてね(^^♪',
        start: '15:50',
        end: '16:10',
        link: 'https://www.instagram.com/littlemama_official/'
      }
    ],
    day2: [
      {
        thumbnail: '/img/channel/01.png',
        title: '朝の会だよ！みんな大集合〜！',
        description: '1日を楽しむためのスケジュールやイベント主催者を紹介☆各チャンネルのおすすめプログラムや今日の楽しみ方をぎゅっとご紹介します♪',
        start: '10:00',
        end: '10:30',
        link: 'https://www.instagram.com/littlemama_official/'
      },
      {
        thumbnail: '/img/channel/06.png',
        title: '関根麻里さんと穴うめビンゴ',
        description: 'マスを決めるのはあなた！お家で紙と鉛筆を用意して参加してね。<br>お題に沿ってオリジナルビンゴを作って挑戦しよう♪<br>テーマ①子どもが好きなこと<br>テーマ②夏と言えば？？どんなビンゴができたかシェアもお待ちしています！<br>なんと！関根麻里さんがゲストで盛り上げ★',
        start: '11:30',
        end: '12:00',
        link: 'https://www.instagram.com/littlemama_official/'
      },
      {
        thumbnail: '/img/channel/05.png',
        title: '0〜1歳ママ大集合！月齢アタックチャレンジ',
        description: '顔が見れないオンライン上に、いったい何人の子育てママが集まってるのか気になりませんか？<br>0歳と1歳のママ、月齢ごとにどの月齢が一番集まるか競争です！<br>見事一番多く集まった月齢のママ達はママ会＆講座にご招待♪<br>初めての育児で不安なママも、ママ友が欲しいママも<br>25日の14時にリトル・ママに集合だ～！',
        start: '14:00',
        end: '14:30',
        link: 'https://www.instagram.com/littlemama_official/'
      },
      {
        thumbnail: '/img/channel/04.png',
        title: '抽選会＆最優秀コンテンツ賞発表',
        description: 'プレゼント抽選会の当選者や最優秀コンテンツ賞を発表します☆<br>みんなの今日の感想も教えてね(^^♪',
        start: '15:50',
        end: '16:10',
        link: 'https://www.instagram.com/littlemama_official/'
      }
    ]
  },
  mutations: {},
  actions: {},
  getters: {
    onair: state => {
      const date = moment()
      let programs = []
      if (date.isSame('2020-06-24', 'day')) {
        programs = state.day1.filter((program) => {
          return date.isBetween('2020-06-24 ' + program.start, '2020-06-24 ' + program.end, 'minute', '[]')
        })
      } else if (date.isSame('2020-06-25', 'day')) {
        programs = state.day2.filter((program) => {
          return date.isBetween('2020-06-25 ' + program.start, '2020-06-25 ' + program.end, 'minute', '[]')
        })
      }
      return programs[0]
    },
    next: state => {
      const date = moment()
      let programs = []
      if (date.isSame('2020-06-24', 'day')) {
        programs = state.day1.filter((program) => {
          return date.isBefore('2020-06-24 ' + program.start)
        })
      } else if (date.isSame('2020-06-25', 'day')) {
        programs = state.day2.filter((program) => {
          return date.isBefore('2020-06-25 ' + program.start)
        })
      }
      return programs[0]
    }
  }
}
